import { useQuery } from '@tanstack/react-query';
import { CrmManyChatInquiriesDto } from '@upme/contracts';
import { api } from '../../../app/api-client';
import { formatDateTime } from '../../users/lib/format';

export function crmManyChatInquiriesOptions(contactId: string) {
  return {
    queryKey: ['admin', 'crm', 'manychat-contacts', contactId, 'inquiries'] as const,
    queryFn: () =>
      api
        .get(`admin/crm/manychat-contacts/${contactId}/inquiries`)
        .json()
        .then((data) => CrmManyChatInquiriesDto.parse(data)),
    enabled: Boolean(contactId),
  };
}

type Props = { contactId: string };

export function CrmManyChatInquiriesSection({ contactId }: Props) {
  const { data, isLoading, isError } = useQuery(crmManyChatInquiriesOptions(contactId));

  if (isLoading) {
    return <p className="text-lg text-muted-foreground">Загрузка обращений…</p>;
  }
  if (isError || !data) {
    return <p className="text-lg text-muted-foreground">Не удалось загрузить историю обращений.</p>;
  }

  return (
    <section className="space-y-2.5 border-t border-border/60 pt-4">
      <h3 className="text-[15px] font-medium uppercase tracking-wide text-muted-foreground">
        Обращения Instagram / ManyChat
      </h3>
      {data.items.length === 0 ? (
        <p className="text-lg text-muted-foreground">Обращений пока нет</p>
      ) : (
        <ul className="space-y-2.5">
          {data.items.map((item) => (
            <li key={item.id} className="rounded-md border border-border/60 px-2.5 py-2 text-lg">
              <p className="text-[15px] text-muted-foreground">
                {formatDateTime(item.occurredAt)} · {item.sourceLabel}
                {item.tagOrScenario ? ` · ${item.tagOrScenario}` : ''}
              </p>
              {item.messageText ? (
                <p className="mt-1 whitespace-pre-wrap">{item.messageText}</p>
              ) : (
                <p className="mt-1 text-muted-foreground">Текст не передан</p>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
